import React from "react";
import "./ajoutClientV2.scss";
import { Box, Typography, Paper } from "@mui/material";
import { COLORS } from "../../settings/themeSettings";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { notify } from "../../settings/toastSetting";
import ClientForm from "../../components/forms/ClientForm";

const styles = {
    container: {
        width: '1000px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.gray[100],
        padding: '15px',
        borderRadius: '5px'
    }
}

const AjoutClient = (props) => {
    const navigateTo = useNavigate();
    const { id } = useParams();
    const { me } = useSelector((state) => state.me);

    useEffect(() => {
        // Interdiction de créer un client si on n'est pas ADMIN
        if (!id && me?.profil && !me.profil.includes('ADMIN')) {
            notify("Accès refusé. La création d'un compte client est réservée à l'administrateur.", "error");
            navigateTo('/billeterie/portefeuil');
        }
    }, [id, me, navigateTo]);

    return (
        <Box className="ajout-client-cyber-container">
            <Box className="cyber-form-header">
                <Typography variant="h4" className="cyber-form-title">
                    {id ? 'Édition' : 'Création'} <span className="highlight">Client</span>
                </Typography>
                <Typography variant="body2" className="cyber-form-subtitle">
                    {id ? 'Modifiez les informations du client dans le portefeuille.' : 'Enregistrez un nouveau client dans votre portefeuille.'}
                </Typography>
            </Box>

            <Paper className="cyber-form-paper" elevation={0}>
                <ClientForm
                    id={id}
                    onSuccess={() => navigateTo('/billeterie/portefeuil')}
                    onCancel={() => navigateTo('/billeterie/portefeuil')}
                />
            </Paper>
        </Box>
    );
}

export default AjoutClient;
